import React from "react";
import { arrayOf, func, bool, string, number } from "prop-types";

import { toInt } from "../../helpers/helpers";
import { Button, Validate } from "../../common";
import * as style from "./styles.module.scss";
import history from "../../history";

import {
  MinSalary,
  WorkHoursOptions,
  Seeking,
  Availability,
} from "../BasicInfo/Edit";

const constraints = {
  positionSeeking: {
    presence: { allowEmpty: false },
  },
};

const WorkType = (props) => {
  const {
    selectedTypes,
    selectedHours,
    minSalary,
    salaryFrequency,
    positionSeeking,
    availabilityDay,
    availabilityMonth,
    availabilityYear,
    toggleHours,
    toggleBothHours,
    onChange,
    handleSubmit,
  } = props;

  const hasSelectedType = (thisType) => selectedTypes.includes(thisType);
  const hasSelectedHours = (thisHours) => selectedHours.includes(thisHours);
  const hasSelectedBothTypes = selectedTypes.length === 2;
  const hasSelectedBothHours = selectedHours.length === 2;

  const availabilityDate = new Date(
    availabilityYear,
    availabilityMonth,
    availabilityDay
  );
  const isValidDate =
    availabilityDate.getDate() === toInt(availabilityDay) &&
    availabilityDate.getMonth() === toInt(availabilityMonth) &&
    availabilityDate.getFullYear() === toInt(availabilityYear);

  const showAvailability = !(
    hasSelectedType("permanent") && !hasSelectedBothTypes
  );

  return (
    <div className="row justify-content-center">
      <div className="col-md-8 col-lg-7">
        <h2 className={style.editWorkType__title}>
          Your work type preferences
        </h2>
        <div className={style.editWorkType__card}>
          <WorkHoursOptions
            hasSelectedBothHours={hasSelectedBothHours}
            hasSelectedFullTimeHours={hasSelectedHours("full")}
            hasSelectedPartTimeHours={hasSelectedHours("part")}
            toggleHours={toggleHours}
            toggleBothHours={toggleBothHours}
          />
          <MinSalary
            handleChange={onChange}
            salaryFrequency={salaryFrequency}
            minSalary={minSalary}
          />
          <Validate constraints={constraints} userInput={{ positionSeeking }}>
            {({ isValid, validation }) => (
              <Seeking
                onChangeHandler={onChange}
                positionSeeking={positionSeeking}
                isValid={isValid}
                validation={validation}
              />
            )}
          </Validate>
          {showAvailability && (
            <div className="my-2">
              <h3>Earliest availability</h3>
              <Availability
                availabilityDay={availabilityDay}
                availabilityMonth={availabilityMonth}
                availabilityYear={availabilityYear}
                onChangeHandler={onChange}
                isInvalid={!isValidDate}
              />
            </div>
          )}

          <div className="w-100 d-flex justify-content-end flex-column-reverse flex-sm-row ">
            <Button
              classes={`btn btn-outline-dark text-dark mb-2 px-3 ${style.editWorkType__button}`}
              onClick={() => history.push("/profile")}
              styles={{ minWidth: "175px" }}
            >
              Back to My Account
            </Button>
            <Validate constraints={constraints} userInput={{ positionSeeking }}>
              {({ isValid }) => (
                <Button
                  classes="btn btn-primary ml-sm-1 mb-1 mb-sm-2 px-3"
                  onClick={
                    isValid || (showAvailability && !isValidDate)
                      ? handleSubmit
                      : () => {}
                  }
                  disabled={!isValid || (showAvailability && !isValidDate)}
                >
                  Save
                </Button>
              )}
            </Validate>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkType.propTypes = {
  onBoarding: bool,
  loading: bool.isRequired,
  selectedTypes: arrayOf(string).isRequired,
  selectedHours: arrayOf(string).isRequired,
  minSalary: number.isRequired,
  salaryFrequency: string.isRequired,
  positionSeeking: string.isRequired,
  availabilityDay: string.isRequired,
  availabilityMonth: string.isRequired,
  availabilityYear: string.isRequired,
  ownCar: bool.isRequired,
  driver: bool.isRequired,
  description: string.isRequired,
  toggleType: func.isRequired,
  toggleBothTypes: func.isRequired,
  toggleHours: func.isRequired,
  toggleBothHours: func.isRequired,
  onChange: func.isRequired,
  handleSubmit: func.isRequired,
  onboardNextRoute: string.isRequired,
};

export default WorkType;
